import { apply, rep_sc, alt, str, list_sc, kmid, rule, tok, lrec_sc, opt_sc, kleft, seq, expectSingleResult, expectEOF, } from "typescript-parsec";
import { tokenizer, TokenKind } from "./tokenizer";
function isOptional(text) {
    return text === "?";
}
/**
 * Expressions
 */
function applyLiteralExpr(value) {
    return {
        kind: "LiteralExpr",
        text: value.text,
    };
}
function applyArrayLiteralExpr(value) {
    return {
        kind: "ArrayLiteralExpr",
        values: value,
    };
}
function applyParenExpr(value) {
    return {
        kind: "ParenExpr",
        expr: value,
    };
}
function applyExprReference(value) {
    var first = value[0], second = value[1], third = value[2];
    var optional = false;
    if (second) {
        if (Array.isArray(second)) {
            optional = isOptional(second[0].text);
        }
        else {
            optional = isOptional(second.text);
        }
    }
    var entity = {
        name: first.text,
        optional: optional,
    };
    var props;
    if (third) {
        for (var _i = 0, third_1 = third; _i < third_1.length; _i++) {
            var name_1 = third_1[_i];
            props = {
                parent: props,
                name: name_1.text,
                optional: !!(name_1.next && name_1.next.text === "?"),
            };
            if (!props.parent) {
                delete props.parent;
            }
        }
    }
    entity.props = props;
    return {
        kind: "ExprReference",
        ref: entity,
    };
}
function applyCallableReference(value) {
    return {
        kind: "CallableExprReference",
        name: value.text,
    };
}
function applyObjectLiteralExpr(value) {
    return {
        kind: "ObjectLiteralExpr",
        properties: value.map(function (prop) {
            return {
                key: prop[0].text,
                value: prop[1],
            };
        }),
    };
}
function applyCallExprLrec(value) {
    return {
        kind: "CallExpr",
        expr: undefined,
        funcArguments: typeof value !== "undefined" ? value : [],
    };
}
function applyTernaryExpr(value) {
    var expr = value[0], t1 = value[1], fullfil = value[2], t2 = value[3], otherwise = value[4];
    return {
        kind: "TernaryExpr",
        expr: expr,
        fullfil: fullfil,
        otherwise: otherwise,
    };
}
function applyExprLrec(first, second) {
    second.expr = first;
    return second;
}
/**
 * Program AST
 */
function applyProgram(value) {
    return {
        kind: "Program",
        statements: value,
    };
}
/**
 * Syntax
 *
 */
export var IDENTIFIER = rule();
export var CALLABLE_TERM = rule();
export var EXPR_TERM = rule();
export var EXPR = rule();
export var CONDITION_EXPR = rule();
export var STAT = rule();
export var PROGRAM = rule();
IDENTIFIER.setPattern(tok(TokenKind.Identifier));
CALLABLE_TERM.setPattern(alt(alt(str("eq"), str("gt"), str("lt"), str("max"), str("min"), str("contains"), str("add"), str("substract"), str("mul"), str("div"), str("and"), str("or"), str("not"), str("values"), str("get")), alt(str("formatDate"), str("formatToTimestamp"))));
EXPR_TERM.setPattern(alt(
// syntax: 字符串，数字，true, false 等 'STRING' 123 true false undefined null
apply(alt(tok(TokenKind.StringLiteral), tok(TokenKind.NumberLiteral), str("true"), str("false"), str("undefined"), str("null")), applyLiteralExpr), 
// syntax: eq() max() 固定的可调用的函数，转换为单独的 kind
apply(alt(alt(tok(TokenKind.EQ), tok(TokenKind.GT), tok(TokenKind.LT), tok(TokenKind.Max), tok(TokenKind.Min), tok(TokenKind.Contains), tok(TokenKind.Add), tok(TokenKind.Substract), tok(TokenKind.Mul), tok(TokenKind.Div), tok(TokenKind.And), tok(TokenKind.Or), tok(TokenKind.Not), tok(TokenKind.Get), tok(TokenKind.Values)), alt(tok(TokenKind.FormatDate), tok(TokenKind.FormatToTimestamp))), applyCallableReference), 
// 表达式引用，如：this this.state
// 只允许引用 this 和 this 下的属性，可以使用 ?. 操作符
// syntax: this[?.B ...]
apply(seq(alt(str("this"), str("$self"), str("$deps"), str("$app")), opt_sc(alt(seq(str("?"), str(".")), str("."))), opt_sc(list_sc(IDENTIFIER, alt(seq(str("?"), str(".")), str("."))))), applyExprReference), 
// syntax: {NAME:EXPR, ...}
apply(kmid(str("{"), list_sc(seq(kleft(tok(TokenKind.Identifier), str(":")), EXPR), str(",")), seq(opt_sc(str(",")), str("}"))), applyObjectLiteralExpr), 
// syntax: [EXPR, ...]
apply(kmid(str("["), list_sc(EXPR, str(",")), str("]")), applyArrayLiteralExpr), 
// syntax: (EXPR)
apply(kmid(str("("), EXPR, str(")")), applyParenExpr)));
EXPR.setPattern(
// syntax: EXPR(EXPR, ...)
lrec_sc(EXPR_TERM, apply(kmid(str("("), opt_sc(kleft(list_sc(EXPR, str(",")), opt_sc(str(",")))), str(")")), applyCallExprLrec), applyExprLrec));
// syntax: (EXPR) ? EXPR : EXPR
CONDITION_EXPR.setPattern(apply(seq(kmid(opt_sc(str("(")), EXPR, opt_sc(str(")"))), str("?"), EXPR, str(":"), EXPR), applyTernaryExpr));
STAT.setPattern(alt(EXPR, CONDITION_EXPR));
PROGRAM.setPattern(apply(rep_sc(STAT), applyProgram));
export function parseStat(input) {
    return expectSingleResult(expectEOF(STAT.parse(tokenizer.parse(input))));
}
export function parseExpr(input) {
    return expectSingleResult(expectEOF(EXPR.parse(tokenizer.parse(input))));
}
export function parseProgram(input) {
    return expectSingleResult(expectEOF(PROGRAM.parse(tokenizer.parse(input))));
}
